import React from "react"
import { Widget } from "./widgets"
import clsx from "clsx"
import { Link } from "gatsby"


import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa"
//import AdContainer from "./AdContainer"

const getSocialIcon = (platform) => {
  switch (platform) {
    case "facebook":
      return <FaFacebook />
    case "instagram":
      return <FaInstagram />
    case "linkedIn":
      return <FaLinkedin />
    case "twitter":
      return <FaTwitter />
    case "youTube":
      return <FaYoutube />
    default:
      return null
  }
}

export const Sidebar = ({ widgets, author, className, ...props }) => {
  const authorImageSize = 170

  const socials = author.seo.social
  const hasSocial = Object.values(socials).some((i) => Boolean(i))

  return (
    <>


      {widgets && widgets.length > 0 && (
        <aside
          className={clsx("sidebar__inner", "px-5 py-10 sm:p-10 space-y-5", className)}
          {...props}
        >
          <div className="text-center card px-4 pt-2 pb-6 mb-12">
            <Link to={author.uri}>
              <img
                src={`${author.avatar.url.replace("s=96", "s=300")}`}
                alt={author.name}
                width={authorImageSize}
                height={authorImageSize}
                className="mx-auto -mt-7 rounded-lg hover:-translate-y-0.5 transition shadow-lg mb-6"
              />
            </Link>
            <p className="uppercase tracking-widest text-base text-slate-500 dark:text-slate-200">
              About the author
            </p>
            <Link
              to={author.uri}
              className="text-xl tracking-widest text-dark dark:text-light !mt-2 mb-2 inline-block hover:underline"
            >
              {author.name}
            </Link>
            {/* Author description */}
            {author.description && (
              <div
                className="pb-4 text-base"
                dangerouslySetInnerHTML={{ __html: author.description }}
                {...props}
              />
            )}
            {/* Author socials */}
            {hasSocial && (
              <div className="flex flex-row flex-wrap justify-center space-x-2 mb-6">
                {Object.keys(socials).map((key) => {
                  if (!socials[key]) return null

                  return (
                    <a
                      key={key}
                      href={socials[key]}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`Follow on ${key}`}
                      className="text-2xl"
                    >
                      {getSocialIcon(key)}
                    </a>
                  )
                })}
              </div>
            )}
            {/* Read Authors posts button */}
            <Link to={author.uri} className="btn btn-ghost">
              See all posts
            </Link>
          </div>
          {widgets.map((widget, i) => (
            <div key={i} className="my-5 first:mt-0">
              <Widget widget={widget} lightBg />
            </div>
          ))}

          <div className="mb-4">


            <div className="adsbyvli" style={{ width: `300px`, height: `600px` }} data-ad-slot="vi_433439546"></div>

            <script dangerouslySetInnerHTML={{ __html: "(vitag.Init = window.vitag.Init || []).push(function () { viAPItag.display('vi_433439546') })" }} />

            {<br></br>}

            <div className="adsbyvli" style={{ width: `300px`, height: `250px` }} data-ad-slot="vi_433439543"></div>

            <script dangerouslySetInnerHTML={{ __html: "(vitag.Init = window.vitag.Init || []).push(function () { viAPItag.display('vi_vi_433439543') })" }} />
            {<br></br>}


            <div className="adsbyvli" style={{ width: `300px`, height: `600px` }} data-ad-slot="vi_433450056"></div>

            <script dangerouslySetInnerHTML={{ __html: "(vitag.Init = window.vitag.Init || []).push(function () { viAPItag.display('vi_433450056') })" }} />




            {<br></br>}

            <script defer id="vidcrunchJS371981280" src="https://cdn.vidcrunch.com/integrations/616fed5708aed317b12bd5d1/Dunebook_Codesource.io_Responsive_Floating_DFP_Rev70_2010.js"></script>



            <script async type="text/javascript" src="//cdn.carbonads.com/carbon.js?serve=CE7DK2JE&placement=codesourceio" id="_carbonads_js"></script>

            <style dangerouslySetInnerHTML={{
              __html: ` #carbonads * {
  margin: initial;
  padding: initial;
}

#carbonads {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    Oxygen-Sans, Ubuntu, Cantarell, 'Helvetica Neue', Helvetica, Arial,
    sans-serif;
}

#carbonads {
  display: flex;
  z-index: 100;
  position: fixed;
  right: 30px;
  bottom: 30px;

  max-width: 330px;
  background-color: hsl(0, 0%, 98%);
  box-shadow:
    0 2px 1px 1px hsla(0, 0%, 0%, .05),
    0 2px 2px 2px hsla(0, 0%, 0%, .05),
    0 2px 4px 4px hsla(0, 0%, 0%, .05);
}

#carbonads a {
  text-decoration: none;
  color: #000;
}

#carbonads a:hover {
  color: #360b3b;
}

#carbonads span {
  display: block;
  position: relative;

  overflow: hidden;
}

#carbonads .carbon-wrap {
  display: flex;
}

#carbonads .carbon-img {
  display: block;
  margin: 0;

  line-height: 1;
}

#carbonads .carbon-img img {
  display: block;
}

#carbonads .carbon-text {
  margin-bottom: 16px;
  padding: 10px;

  font-size: 13px;
  line-height: 1.5;
  text-align: left;
}

#carbonads .carbon-poweredby {
  display: block;
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 6px 8px;

  font-size: 8px;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  border-top-left-radius: 3px;
  background: #f1f1f2;
}

@media only screen and (min-width: 320px) and (max-width: 759px) {
  #carbonads {
    float: initial;
    position: relative;
    right: initial;
    bottom: initial;
    margin: 0 auto;

    max-width: 330px;
  }

  #carbonads .carbon-wrap {
    display: flex;

    flex-direction: row;
  }

  #carbonads .carbon-img {
    margin: 0;
  }

  #carbonads .carbon-text {
    padding: 10px 10px 0 10px;

    font-size: 12px;
  }

  #carbonads .carbon-poweredby {
    position: absolute;
    right: 0;
    bottom: 0;

    text-align: center;
    border-radius: 0;
    border-top-left-radius: 3px;
  }
}
                
  `}} />


          </div>
        </aside>
      )}
    </>
  )
}


